// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1150":"6884259a8a248704","1507":"a203aeb8e9091970","7829":"a465a077fd885697","9463":"cf94e6daae2aaf76"}[chunkId] + ".css";
};